import { useEffect } from 'react';

/**
 * UpdateNotification Component
 * Automatically reloads the app when a new version is detected
 * No user interaction required
 */
function UpdateNotification() {
  useEffect(() => {
    // Listen for service worker update messages
    const handleMessage = (event) => {
      if (event.data && event.data.type === 'SW_UPDATED') {
        console.log('[UpdateNotification] New version detected:', event.data.version);
        console.log('[UpdateNotification] Auto-reloading to activate new version...');

        // Auto-reload immediately to activate new version
        window.location.reload();
      }
    };

    navigator.serviceWorker?.addEventListener('message', handleMessage);

    return () => {
      navigator.serviceWorker?.removeEventListener('message', handleMessage);
    };
  }, []);

  // No UI needed - automatic reload
  return null;
}

export default UpdateNotification;
